module.exports = __webpack_public_path__ + "img/qgis-logo.c7338889.svg";